import { render, staticRenderFns } from "./UserLearningStatsPage.vue?vue&type=template&id=446e5332&scoped=true"
import script from "./UserLearningStatsPage.vue?vue&type=script&lang=js"
export * from "./UserLearningStatsPage.vue?vue&type=script&lang=js"
import style0 from "./UserLearningStatsPage.vue?vue&type=style&index=0&id=446e5332&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "446e5332",
  null
  
)

export default component.exports